//import React from 'react'
import { Expenses_microLegend } from '../../views/FamilyProgram/FamilyExpenses'
import { Housing_microLegend } from '../../views/FamilyProgram/FamilyHousing'
import { Income_microLegend } from '../../views/FamilyProgram/FamilyIncome'
import { PImicroLegend } from '../../views/FamilyProgram/FamilyContact'
import { Debts_microLegend } from '../../views/FamilyProgram/FamilyDebts'
import { DebtsStatus_microLegend } from '../../views/FamilyProgram/FamilyDebtsStatus'
import { Kids_microLegend } from '../../views/FamilyProgram/FamilyKids'
import { Legal_microLegend } from '../../views/FamilyProgram/FamilyLegal'
import { Mortgage_microLegend } from '../../views/FamilyProgram/FamilyMortgage'
import { questionnareFields } from '../../views/FamilyProgram/FamilyProgramQ'
import { Rights_microLegend } from '../../views/FamilyProgram/FamilyRights'
import { RightsQ_microLegend } from '../../views/FamilyProgram/FamilyRightsQ'
import { NS_microLegend } from '../../views/FamilyProgram/NeedSolutionsTable'
import { MS_Translation } from '../../views/FamilyProgram/MeetingSummaryTable'

import { ParentEducation_microLegend } from '../../views/FamilyParent/ParentEducation'
import { Diploma_microLegend } from '../../views/FamilyParent/ParentDiploma'
import { EmployBoz_microLegend } from '../../views/FamilyParent/ParentEmployBoz'
import { EmployHistory_microLegend } from '../../views/FamilyParent/ParentEmployHistory'
import { Employment_microLegend } from '../../views/FamilyParent/ParentEmployment'
import { ParentInfo_microLegend } from '../../views/FamilyParent/ParentGeneral'
import { HealthStatus_microLegend } from '../../views/FamilyParent/ParentHealthStatus'
import { HealthIssues_microLegend } from '../../views/FamilyParent/ParentHealth'
import { NotEmployed_microLegend } from '../../views/FamilyParent/ParentNotEmployed'
import { ParentQuestionnaireFields } from '../../views/FamilyParent/ParentQuestionnairePre'



const do_translate = (line, tanslation, entity) => {
    //console.log('do_translate line=', line)
    if (line === undefined || !Array.isArray(line) || line === 'm')
        return line
    let x = line.map((col, index) => {
        if (index === 0) return entity
        if (tanslation[col] === undefined) 
            return col
        return tanslation[col]
    })
    return x
}
export const qb_translateLine = (line, tab) => {
    let families = 'משפחות'
    let parents = 'הורים'
    switch(tab){
        case "הוצאות המשפחה" :  return do_translate(line, Expenses_microLegend, families)
        case "הכנסות המשפחה" :  return do_translate(line, Income_microLegend, families)
        case "מצב מגורים" :     return do_translate(line, Housing_microLegend, families)
        case "סטטוס משפחה בתכנית" : return do_translate(line, PImicroLegend, families)
        case "מצב חובות" :      return do_translate(line, DebtsStatus_microLegend, families)
        case "חובות משפחה" :    return do_translate(line, Debts_microLegend, families)
        case "ילדי משפחה" :     return do_translate(line, Kids_microLegend, families)
        case "מצב משפטי" :      return do_translate(line, Legal_microLegend, families) 
        case "מיצוי זכויות" :   return do_translate(line, Rights_microLegend, families) 
        case "משכנתא" :         return do_translate(line, Mortgage_microLegend, families) 
        case "שאלון זכויות" :   return do_translate(line, RightsQ_microLegend, families) 
        case "צרכים ומענים" :   return do_translate(line, NS_microLegend, families) 
        case "סיכומי מפגש משפחה" :   return do_translate(line, MS_Translation, families) 
        case "שאלון חוות דעת ושביעות רצון- אחרי שנה" :  return do_translate(line, questionnareFields, families) 
        case "שאלון חוות דעת ושביעות רצון- אחרי שנתיים":return do_translate(line, questionnareFields, families) 

        case "השכלה - הורים" :  return do_translate(line, ParentEducation_microLegend, parents) 
        case "הכשרה הורה" :     return do_translate(line, Diploma_microLegend, parents) 
        case "עבודות במקביל" :  return do_translate(line, EmployBoz_microLegend, parents) 
        case "הסטוריה תעסוקתית" :   return do_translate(line, EmployHistory_microLegend, parents) 
        case "תעסוקת הורה" :        return do_translate(line, Employment_microLegend, parents) 
        case "פרטים אישיים הורים" : return do_translate(line, ParentInfo_microLegend, parents) 
        case "מצב בריאות הורים" :   return do_translate(line, HealthStatus_microLegend, parents) 
        case "בעיות בריאות הורים" : return do_translate(line, HealthIssues_microLegend, parents) 
        case "בלתי מועסקים - הורה" :return do_translate(line, NotEmployed_microLegend, parents) 
        case "שאלון עמדות בתחילת התכנית" : return do_translate(line, ParentQuestionnaireFields, parents) 
        case "שאלון עמדות בסיום התכנית" :  return do_translate(line, ParentQuestionnaireFields, parents)         
        default: return line;
    }
               
    //Smart React detects Unreachable... return line // do nothing, default...
}
/*
if (tab === "הוצאות המשפחה" || tab === "family_expenses")
        return do_translate(line, Expenses_microLegend, families)
    
    if (tab === "הכנסות המשפחה" || tab === "family_income")
        return do_translate(line, Income_microLegend, families)

    if (tab === "מצב מגורים" || tab === "family_housing")
        return do_translate(line, Housing_microLegend, families)

    if (tab === "סטטוס משפחה בתכנית" || tab === "some_value")
        return do_translate(line, PImicroLegend, families)
    
    if (tab === "מצב חובות" || tab === "some_value")
        return do_translate(line, DebtsStatus_microLegend, families)

    if (tab === "חובות משפחה" || tab === "some_value")
        return do_translate(line, Debts_microLegend, families)

    if (tab === "ילדי משפחה" || tab === "some_value")
        return do_translate(line, Kids_microLegend, families)

    if (tab === "מצב משפטי" || tab === "some_value")
        return do_translate(line, Legal_microLegend, families)
        */